class CreateProjectNotify {
  static getEmailData = (dst, user, project) => {
    const from = `Gobierno de El Salvador <info@goes.gob.sv>`;

    const to = dst;
    const subject = `Un nuevo proyecto o requerimiento fue enviado`;
    const body = templeteData(user, project);

    return {
      from,
      to,
      subject,
      body
    };
  };
}

export default CreateProjectNotify;

const templeteData = (user, project) => {
  return `
    <h2 style="text-align: center;">
      Solicitud de acceso al Portal de Proyectos Gobierno de El Salvador
    </h2>
    <br />
    <p>Estimado(a) Administrador,</p>
    <br />
    <p>
      Queremos informarte que usuario <strong>${user?.displayName}</strong> del <strong>${
    JSON.parse(user?.reloadUserInfo?.customAttributes).dependence
  }</strong>, ha enviando un nuevo requerimiento, estos son algunos detalles del proyecto:.
    </p>
    <br />
      <p> 
        <h3>${project.ministerio}</h3>
        <p><strong>Datos de contacto:</strong> 
            ${user?.email} - ${user?.phoneNumber}
        </p>
        <p><strong>Titulo:</strong> 
            ${project.title}
        </p>
        <p><strong>Descipción:</strong> 
            ${project.resumenProyecto}
        </p>
      </p>
    <br />
    <p>
      Para conocer mas acerca del proyecto, visita el Portal y revisa tus pendientes <a href="${'https://portal.modernizacion.gob.sv'}">aquí</a>, te estaremos informando acerca de mas solicitudes.
    </p>
    <br />
    <br />
    <p>Saludos,</p>
    <br />
    <p>Portal de Proyectos Gobierno de El Salvador en Convenio con Google LLC</p>
  `;
};
